
export const ARCGIS_ACCESS_TOKEN = "arcgis_access_token"